import { showLogin, showRegister } from "actions/ui_control";

import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Collapse } from "react-bootstrap";
import { useDispatch } from "react-redux";

function PricingSection() {
  const [expandInfo1, setExpandInfo1] = useState(1);
  const [expandInfo2, setExpandInfo2] = useState(1);
  const [expandInfo3, setExpandInfo3] = useState(1);
  const dispatch = useDispatch();

  // Set the expandInfo values based on the screen size
  const setExpandInfoValues = () => {
    // Use a CSS media query to determine the screen size
    const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
    setExpandInfo1(isSmallScreen ? 0 : 1);
    setExpandInfo2(isSmallScreen ? 0 : 1);
    setExpandInfo3(isSmallScreen ? 0 : 1);
  };

  // Call setExpandInfoValues on mount and whenever the window size changes
  useEffect(() => {
    setExpandInfoValues();
    window.addEventListener("resize", setExpandInfoValues);
    return () => window.removeEventListener("resize", setExpandInfoValues);
  }, []);
  const displayRegister = () => {
    dispatch(showRegister());
  };
  return (
    <section id="pricing-section">
      <h3
        className="text-center mb-3"
        style={{ fontSize: "36px", lineHeight: "40px" }}
      >
        Plans according to your needs:
      </h3>
      <Container className="mt-5">
        {/*<h3 className="text-center mb-3">Pricing</h3>*/}
        <Row className="justify-content-center">
          <Col md={4} sm={12} className="mb-4 pricing-card-1">
            <Card
              className="border-0"
              style={{
                margin: "auto",
                borderRadius: "10px",
                maxWidth: "290px",
                background: "#E5EDF4",
              }}
            >
              <Card.Body className="">
                <h2 className="mb-4">
                  $10
                  <span style={{ marginLeft: "4px", fontSize: "18px" }}>
                    monthly
                  </span>
                </h2>
                <h4 className="mb-1">
                  Base Plan
                  <i
                    className={`d-block d-md-none bi bi-arrow-${
                      expandInfo3 === 1 ? "up" : "down"
                    }-circle button-expand`}
                    style={{ background: "#E5EDF4ff" }}
                    onClick={() => setExpandInfo3(expandInfo3 === 1 ? 0 : 1)}
                  ></i>
                </h4>
                <small>Monitor and Purchase automated</small>
                <Collapse in={expandInfo3 === 1}>
                  <ul className="list-unstyled mt-3">
                    <li>
                      <i className="bi bi-check text-success mb-3 me-2"></i>{" "}
                      Automated Buy Stocks & ETFs
                    </li>
                    <li>
                      <i className="bi bi-x text-danger mb-3 me-2"></i>{" "}
                      Automated Sell Stocks & ETFs
                    </li>
                    <li>
                      <i className="bi bi-check text-success mb-3 me-2"></i>{" "}
                      Notifications with details
                    </li>
                    <li>
                      <i className="bi bi-check text-success mb-3 me-2"></i> 2
                      Broker accounts
                    </li>
                    <li>
                      <i className="bi bi-x text-danger mb-3 me-2"></i> Cash
                      Secured Puts
                    </li>
                    <li>
                      <i className="bi bi-x text-danger mb-3 me-2"></i> Covered
                      Calls
                    </li>
                    <li>
                      <i className="bi bi-x text-danger mb-3 me-2"></i>{" "}
                      Intelligent Portfolio Builder
                    </li>
                    <li>
                      <i className="bi bi-x text-danger mb-3 me-2"></i> Specific
                      Feature Request
                    </li>
                    {/*  <li>*/}
                    {/*    <i className="bi bi-x text-danger mb-3 me-2"></i> Tax*/}
                    {/*    based suggestions*/}
                    {/*  </li>*/}
                    {/*  <li>*/}
                    {/*    <i className="bi bi-x text-danger mb-3 me-2"></i> Funding*/}
                    {/*    round preference*/}
                    {/*  </li>*/}
                  </ul>
                </Collapse>
                <div className="mt-4">
                  <button
                    onClick={displayRegister}
                    style={{ width: "100%", height: "38px" }}
                    className="btn button-purple-gradient me-3"
                  >
                    Start
                  </button>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} sm={12} className="mb-4 pricing-card-2">
            <Card
              className="border-0"
              style={{
                margin: "auto",
                borderRadius: "10px",
                maxWidth: "290px",
              }}
            >
              <Card.Body className="">
                <h2 className="mb-4">
                  $20
                  <span style={{ marginLeft: "4px", fontSize: "18px" }}>
                    monthly
                  </span>
                </h2>
                <h4 className="mb-1">
                  Investor Plan
                  <i
                    className={`d-block d-md-none bi bi-arrow-${
                      expandInfo1 === 1 ? "up" : "down"
                    }-circle button-expand`}
                    onClick={() => setExpandInfo1(expandInfo1 === 1 ? 0 : 1)}
                  ></i>
                </h4>
                <small>Set and forget Buy or sell</small>
                <Collapse in={expandInfo1 === 1}>
                  <ul className="list-unstyled mt-3">
                    <li>
                      <i className="bi bi-check text-success mb-3 me-2"></i>{" "}
                      Automated Buy Stocks & ETFs
                    </li>
                    <li>
                      <i className="bi bi-check text-success mb-3 me-2"></i>{" "}
                      Automated Sell Stocks & ETFs
                    </li>
                    <li>
                      <i className="bi bi-check text-success mb-3 me-2"></i>{" "}
                      Notifications with details
                    </li>
                    <li>
                      <i className="bi bi-check text-success mb-3 me-2"></i> 5
                      Broker accounts
                    </li>
                    <li>
                      <i className="bi bi-x text-danger mb-3 me-2"></i> Cash
                      Secured Puts
                    </li>
                    <li>
                      <i className="bi bi-check text-success mb-3 me-2"></i>{" "}
                      Covered Calls
                    </li>
                    <li>
                      <i className="bi bi-x text-danger mb-3 me-2"></i>{" "}
                      Intelligent Portfolio Builder
                    </li>
                    <li>
                      <i className="bi bi-x text-danger mb-3 me-2"></i> Specific
                      Feature Request
                    </li>
                    {/*<li>*/}
                    {/*  <i className="bi bi-x text-danger mb-3 me-2"></i> Tax*/}
                    {/*  based suggestions*/}
                    {/*</li>*/}
                    {/*<li>*/}
                    {/*  <i className="bi bi-x text-danger mb-3 me-2"></i> Funding*/}
                    {/*  round preference*/}
                    {/*</li>*/}
                  </ul>
                </Collapse>
                <div className="mt-4">
                  <a
                    href="#"
                    onClick={(e) => e.preventDefault()}
                    style={{ width: "100%", height: "38px" }}
                    className="btn button-purple-gradient me-3 d-flex align-items-center"
                  >
                    Start
                  </a>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} sm={12} className="mb-4  pricing-card-3">
            <Card
              className="border-0"
              style={{
                margin: "auto",
                borderRadius: "10px",
                maxWidth: "290px",
              }}
            >
              <Card.Body className="">
                <h2 className="mb-4">
                  $40
                  <span style={{ marginLeft: "4px", fontSize: "18px" }}>
                    monthly
                  </span>
                </h2>
                <h4 className="mb-1">
                  Smart Investor Plan
                  <i
                    className={`d-block d-md-none bi bi-arrow-${
                      expandInfo2 === 1 ? "up" : "down"
                    }-circle button-expand`}
                    onClick={() => setExpandInfo2(expandInfo2 === 1 ? 0 : 1)}
                  ></i>
                </h4>
                <small>Options and Tax optimization</small>
                <Collapse in={expandInfo2 === 1}>
                  <ul className="list-unstyled mt-3">
                    <li>
                      <i className="bi bi-check text-success mb-3 me-2"></i>{" "}
                      Automated Buy Stocks & ETFs
                    </li>
                    <li>
                      <i className="bi bi-check text-success mb-3 me-2"></i>{" "}
                      Automated Sell Stocks & ETFs
                    </li>
                    <li>
                      <i className="bi bi-check text-success mb-3 me-2"></i>{" "}
                      Notifications with details
                    </li>
                    <li>
                      <i className="bi bi-check text-success mb-3 me-2"></i> 10
                      Broker accounts
                    </li>
                    <li>
                      <i className="bi bi-check text-success mb-3 me-2"></i>{" "}
                      Cash Secured Puts
                    </li>
                    <li>
                      <i className="bi bi-check text-success mb-3 me-2"></i>{" "}
                      Covered Calls
                    </li>
                    <li>
                      <i className="bi bi-check text-success mb-3 me-2"></i>{" "}
                      Intelligent Portfolio Builder
                    </li>
                    <li>
                      <i className="bi bi-check text-success mb-3 me-2"></i>{" "}
                      Specific Feature Request
                    </li>
                    {/*<li>*/}
                    {/*  <i className="bi bi-check text-success mb-3 me-2"></i> Tax*/}
                    {/*  based suggestions*/}
                    {/*</li>*/}
                    {/*<li>*/}
                    {/*  <i className="bi bi-check text-success mb-3 me-2"></i>{" "}*/}
                    {/*  Funding round preference*/}
                    {/*</li>*/}
                  </ul>
                </Collapse>
                <div className="mt-4">
                  <a
                    href="#"
                    onClick={(e) => e.preventDefault()}
                    style={{ width: "100%", height: "38px" }}
                    className="btn button-purple-gradient me-3 d-flex align-items-center"
                  >
                    Start
                  </a>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default PricingSection;
